// The one intentionally-impure entropy source for level generation. Level
// generation itself (`generateLevel`/`createRandomLevel` in
// `src/core/levels.ts`) stays a pure, seed-deterministic function; this tiny
// adapter is the only place that calls into a non-deterministic browser API,
// kept separate so the pure core remains fully unit-testable.
export function randomSeed(): number {
  return Math.floor(Math.random() * 0x100000000);
}
